import React, { useState } from 'react';
import { AppProvider, useApp } from './context/AppContext';
import Splash from './components/Splash';
import Login from './components/Login';
import AdminDashboard from './components/AdminDashboard';
import HistoryPage from './components/HistoryPage';
import ProfilePage from './components/ProfilePage';

// Inner component to access Context
const AppContent = () => {
  const { user } = useApp();
  const [screen, setScreen] = useState('splash');

  // 1. If we are still in splash, show splash
  if (screen === 'splash') {
    return <Splash onFinish={() => setScreen('dashboard')} />;
  }

  // 2. If no user is logged in, force Login screen
  if (!user) {
    return <Login onLogin={() => setScreen('dashboard')} />;
  }

  // 3. If user exists, allow navigation
  return (
    <>
      {screen === 'dashboard' && <AdminDashboard onNav={setScreen} />}
      {screen === 'history' && <HistoryPage onNav={setScreen} />}
      {screen === 'profile' && <ProfilePage onNav={setScreen} />}
    </>
  );
};

export default function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}